import * as React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './Article.module.scss';

interface ArticleProps {
    title: string;
    image: string;
    expert?: {
        expertName: string;
        expertTitle: string;
        expertAvatar: string;
    };
    content: React.ReactNode;
}

export const Article = ({ title, image, content, expert }: ArticleProps) => {
    const { t } = useTranslation();

    return (
        <div className={styles.wrapper}>
            <img className={styles.heroImage} src={image} alt="" loading="eager" fetchPriority="high" />

            <main className={styles.drawer}>
                <h1 className={styles.title}>{title}</h1>
                {expert && (
                    <div className={styles.author}>
                        <img src={expert.expertAvatar} alt="" className={styles.authorImage} />
                        <div>
                            <div className={styles.authorTitle}>{t('article.curatedBy')}</div>
                            <div className={styles.authorName}>
                                {expert.expertName} ⋅ {expert.expertTitle}
                            </div>
                        </div>
                    </div>
                )}
                {content}
            </main>
        </div>
    );
};
